export default "__VITE_ASSET__BINCvgZW__"